import { shopOperationError } from "./shopLabels";
import React, { useEffect, useState } from 'react';
import { isAuthenticated } from '../auth';
import { setShopProductPrice } from '../auth/apiShops';
import { elakayAutoText as text } from '../pageInside/dataElakay';
export default function ProductShopPriceEditor({ product, shop, onSaved }) {
  const [price, setPrice] = useState(''), [busy, setBusy] = useState(false), [error, setError] = useState('');
  useEffect(() => { setPrice(String(product?.shopPrices?.find((p) => String(p.shopId) === String(shop?._id))?.price ?? '')); setError(''); }, [product, shop?._id]);
  if (!shop?._id || String(isAuthenticated()?.user?._id) !== String(product?.owner?._id || product?.owner)) return null;
  const save = async () => {
    setBusy(true); setError('');
    try { await setShopProductPrice(shop._id, product._id, price === '' ? null : Number(price)); onSaved?.(); }
    catch (failure) { setError(shopOperationError(failure)); }
    finally { setBusy(false); }
  };
  return <div className="border rounded p-2">
    <label>{text('h_msl_price', 'Shop price (empty uses the existing product price)')}
      <input className="form-control" type="number" min="0.01" step="0.01" value={price} onChange={(event) => setPrice(event.target.value)} />
    </label>
    <button className="btn btn-primary ms-2" disabled={busy} onClick={save}>{text('h_msl_save', 'Save')}</button>
    {error && <div role="alert">{error}</div>}
  </div>;
}
